










































































































import { Component, Vue } from "vue-property-decorator";
import DictSelect from "../../components/dict-select.vue";
import { getAccidentList } from "@/api/accident/list";

@Component({
  name: "RemoteListHeader",
  components: {
    DictSelect,
  },
})
export default class remoteListHeader extends Vue {
  public query: object = {
    accidentId: "",
    accidentStartDate: "",
    accidentEndDate: "",
  };
  public pagination: object = {
    page: 1,
    size: 10,
    total: 0,
  };
  public isUnfold: boolean = false;
  public loading: boolean = false;
  public pickerOptions: object = {
    shortcuts: [
      {
        text: "最近一周",
        onClick(picker) {
          const end = new Date();
          const start = new Date();
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
          picker.$emit("pick", [start, end]);
        },
      },
      {
        text: "最近一个月",
        onClick(picker) {
          const end = new Date();
          const start = new Date();
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
          picker.$emit("pick", [start, end]);
        },
      },
      {
        text: "最近三个月",
        onClick(picker) {
          const end = new Date();
          const start = new Date();
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
          picker.$emit("pick", [start, end]);
        },
      },
    ],
  };
  public accidentDate: string = "";
  public async search() {
    console.log(this.query, 111);
    if (this.accidentDate.length > 0) {
      const [startTiem, endTime] = this.accidentDate;
      // @ts-ignore
      this.query.accidentStartDate = startTiem;
      // @ts-ignore
      this.query.accidentEndDate = endTime;
    }
    // @ts-ignore
    this.pagination.page = 1;
    this.loading = true;

    let res = await getAccidentList(
      {
        ...this.query,
      },
      this.pagination
    );
    console.log(res.data.list);
    const listKeys = Object.keys(res.data.list);
    const listData = [];
    listKeys.map((item: string) => {
      //@ts-ignore
      listData.push(res.data.list[item]);
    });
    console.log(res.data.total);

    this.$emit("searchUpdata", { list: listData, total: res.data.total });
    this.$store.commit("app/SET_SEARCHCONDITION", { ...this.query });
    this.loading = false;
  }
}
